import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { Form, Formik, FormikValues } from 'formik';
import React, { useRef, useEffect } from 'react';

import FormikButton from '../../common/formik/FormikButton';
import FormikGrid from '../../common/formik/FormikGrid';
import FormikTextField from '../../common/formik/FormikTextField';
import { useCreateCapa } from './Capa.hook';
// import { capaValidationSchema } from './CapaDetailPage';

export type CapaCreateDialogProps = DialogProps & { close?: () => void };

export const CapaCreateDialog: React.FC<CapaCreateDialogProps> = props => {
  const { close, ...dialogProps } = props;
  const formikRef = useRef<FormikValues>();
  const [{ error, isLoading, data }, post] = useCreateCapa();

  useEffect(() => {
    if (!isLoading && data && close) close();
  }, [close, data, isLoading]);

  return (
    <Dialog {...dialogProps}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{ title: '' }}
        // validationSchema={capaValidationSchema}
        onSubmit={capa => post({ ...capa })}
      >
        <Form autoComplete='off'>
          <DialogTitle>New CAPA</DialogTitle>
          <DialogContent>
            <FormikGrid>
              <FormikTextField name='title' label='Title' autoFocus={true} />
            </FormikGrid>
            {error && (
              <Alert severity='error'>Error occurred. {error.message}</Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={close}>Cancel</Button>
            <FormikButton>Create</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default CapaCreateDialog;
